import type { ComponentType } from 'react';
import type { BoundFilterProps, FilterProps } from './types';
import { useBindFilter } from './use-bind-filter';

export function createFilter<P extends FilterProps>(
  FilterComponent: ComponentType<P>
) {
  const displayName = FilterComponent.displayName || FilterComponent.name;

  const FilterBound = ({
    filterName,
    ...forwardingProps
  }: BoundFilterProps<P>) => {
    const filter = useBindFilter<P['filter']['selectedValue']>(filterName);

    const controlProps = {
      ...forwardingProps,
      filter
    } as unknown as P;

    return <FilterComponent {...controlProps} />;
  };
  FilterBound.displayName = `ControlBound(${displayName})`;

  const FilterRelay = (props: BoundFilterProps<P> | P) => {
    function isBoundFilterProps<P>(props: any): props is BoundFilterProps<P> {
      return props && 'filterName' in props;
    }

    if (isBoundFilterProps<P>(props)) {
      return <FilterBound {...props} />;
    }

    return <FilterComponent {...props} />;
  };
  FilterRelay.displayName = `ControlRelay(${displayName})`;

  return FilterRelay;
}
